function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3149 13.2265C11.0057 12.9173 11.0057 12.416 11.3149 12.1069C11.624 11.7977 12.1253 11.7977 12.4345 12.1069L15.6011 15.2735C15.9103 15.5827 15.9103 16.084 15.6011 16.3931C15.292 16.7023 14.7907 16.7023 14.4815 16.3931L11.3149 13.2265Z",
  fill: "#B5B5C3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.16699 8.70834C3.16699 11.7689 5.64808 14.25 8.70866 14.25C11.7692 14.25 14.2503 11.7689 14.2503 8.70834C14.2503 5.64776 11.7692 3.16667 8.70866 3.16667C5.64808 3.16667 3.16699 5.64776 3.16699 8.70834ZM12.667 8.70834C12.667 10.8945 10.8948 12.6667 8.70866 12.6667C6.52253 12.6667 4.75033 10.8945 4.75033 8.70834C4.75033 6.52221 6.52253 4.75001 8.70866 4.75001C10.8948 4.75001 12.667 6.52221 12.667 8.70834Z",
  fill: "#B5B5C3"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.d1afcce5.svg";
export { ForwardRef as ReactComponent };